import { render, staticRenderFns } from "./EmployeesNavigation.vue?vue&type=template&id=11da71f4&scoped=true"
import script from "./EmployeesNavigation.vue?vue&type=script&lang=ts"
export * from "./EmployeesNavigation.vue?vue&type=script&lang=ts"
import style0 from "./EmployeesNavigation.vue?vue&type=style&index=0&id=11da71f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11da71f4",
  null
  
)

export default component.exports